import { Typography, TypographyProps } from '../../core/Typography'
import { styled } from '../../styles'

export const StyledMainWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: 4,
})

export const StyledLabelWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
})

export const StyledLabelInnerWrapper = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  gap: 4,
})

type StyledHelpIconWrapperProps = {
  isActiveOrFocus?: boolean
  error?: boolean
}

export const StyledHelpIconWrapper = styled('div')<StyledHelpIconWrapperProps>(({ isActiveOrFocus, error, theme }) => ({
  display: 'flex',
  alignItems: 'center',
  '& svg': {
    width: 16,
    height: 16,
  },
  '& .OSUI-material-symbols': {
    fontSize: '16px !important',
    color: error
      ? `${theme.palette.red[800]}`
      : isActiveOrFocus
      ? `${theme.palette.blue[800]}`
      : `${theme.palette.neutralGrey[1300]}`,
  },
}))

type SelectOptionLabelProps = TypographyProps & {
  isActiveOrFocus?: boolean
  error?: boolean
}

export const StyledOptionLabel = styled(Typography)<SelectOptionLabelProps>(({ error, isActiveOrFocus, theme }) => ({
  color: error
    ? `${theme.palette.red[800]}`
    : isActiveOrFocus
    ? `${theme.palette.blue[800]}`
    : `${theme.palette.neutralGrey[1300]}`,
}))
